import * as logsActions from '../actions/logs';
import { objectFromArray } from '../helpers';

export const initialState = {
  inflight: false,
  byId: {},
  byUserId: {},
  byRescueId: {},
  byDonationId: {},
  byPickupSpecId: {},
  byFoodDonorId: {},
  byReceiverId: {},
  lastUpdated: null,
};

const logsReducer = (state = initialState, action) => {
  switch (action.type) {
    case logsActions.REQUEST_LOGS:
      return {
        ...state,
        inflight: true,
      };
    case logsActions.RECEIVE_USER_LOGS:
      return {
        ...state,
        inflight: false,
        byId: {
          ...state.byId,
          ...objectFromArray(action.logs, (log) => log.id),
        },
        byUserId: {
          ...state.byUserId,
          [action.userId]: action.logs,
        },
        lastUpdated: action.receivedAt,
      };
    case logsActions.RECEIVE_RESCUE_LOGS:
      return {
        ...state,
        inflight: false,
        byId: {
          ...state.byId,
          ...objectFromArray(action.logs, (log) => log.id),
        },
        byRescueId: {
          ...state.byRescueId,
          [action.rescueId]: action.logs,
        },
        lastUpdated: action.receivedAt,
      };
    case logsActions.RECEIVE_PICKUP_SPEC_LOGS:
      return {
        ...state,
        inflight: false,
        byId: {
          ...state.byId,
          ...objectFromArray(action.logs, (log) => log.id),
        },
        byPickupSpecId: {
          ...state.byPickupSpecId,
          [action.pickupSpecId]: action.logs,
        },
        lastUpdated: action.receivedAt,
      };
    case logsActions.RECEIVE_DONATION_LOGS:
      return {
        ...state,
        inflight: false,
        byId: {
          ...state.byId,
          ...objectFromArray(action.logs, (log) => log.id),
        },
        byDonationId: {
          ...state.byDonationId,
          [action.donationId]: action.logs,
        },
        lastUpdated: action.receivedAt,
      };
    case logsActions.RECEIVE_FOOD_DONOR_LOGS:
      return {
        ...state,
        inflight: false,
        byId: {
          ...state.byId,
          ...objectFromArray(action.logs, (log) => log.id),
        },
        byFoodDonorId: {
          ...state.byFoodDonorId,
          [action.foodDonorId]: action.logs,
        },
        lastUpdated: action.receivedAt,
      };
    case logsActions.RECEIVE_RECEIVING_AGENCY_LOGS:
      return {
        ...state,
        inflight: false,
        byId: {
          ...state.byId,
          ...objectFromArray(action.logs, (log) => log.id),
        },
        byReceiverId: {
          ...state.byReceiverId,
          [action.receiverId]: action.logs,
        },
        lastUpdated: action.receivedAt,
      };
    default:
      return state;
  }
};

export default logsReducer;
